import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Switch, Link, Routes, BrowserRouter } from 'react-router-dom';
import Home from './Home';
import About from './About';
import Projects from './Project';
import Interests from './Contact';
function Header() {
  const [isOpen, setIsOpen] = useState(false);
/* Developed by Arul */
  const handleMenuClick = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className={`navbar ${isOpen ? 'nav-open' : ''}`}>
      <div className="tophead">
        <h1>
          <a className="name-logo" href="#home">
            Coder
          </a>
          <span className="blink"></span>
        </h1>
        <div
          className={`menu-btn ${isOpen ? 'opened-btn' : ''}`}
          onClick={handleMenuClick}
        ></div>
      </div>
      <ul className={`menu ${isOpen ? 'open' : ''}`}>
        <li>
          <a href="#home">Home</a>
        </li>
        <li>
          <a href="#about">About</a>
        </li>
        <li>
          <a href="#projects">Projects</a>
        </li>
        <li>
          <a href="#contact">Interests</a>
        </li>
      </ul>
    </nav>

  );
}

export default Header;
